import { useCallback, useContext } from 'react'

import {
  AppLocationContext,
  AppLocationFragment,
  TOPIC_VIEW,
} from '../../pages/admin/app_location_provider'
import { isLiveChatApp } from '../../reduxes/slices/live_chat_app/selectors'
import { useSelectorDelegateStore } from '../../reduxes/stores/root_store/hooks'

export const useNavAndClearSelected = () => {
  const { setAppLocation } = useContext(AppLocationContext)
  const liveChatApp = useSelectorDelegateStore(isLiveChatApp)

  return useCallback(
    (url, options: AppLocationFragment = {}) => {
      return setAppLocation({
        url,
        topicId: null,
        directChatHandle: null,
        topicView: TOPIC_VIEW.CHAT_VIEW,
        ...(!liveChatApp && { welcomeMessageId: null }),
        videoCollectionId: null,
        ...options,
      })
    },
    [liveChatApp, setAppLocation],
  )
}
